var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 7C1.25 3.82436 3.82436 1.25 7 1.25H17C20.1756 1.25 22.75 3.82436 22.75 7V17C22.75 20.1756 20.1756 22.75 17 22.75H7C3.82436 22.75 1.25 20.1756 1.25 17V7ZM7 2.75C4.65279 2.75 2.75 4.65279 2.75 7V17C2.75 19.3472 4.65279 21.25 7 21.25H17C19.3472 21.25 21.25 19.3472 21.25 17V7C21.25 4.65279 19.3472 2.75 17 2.75H7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 17.7273 21.8447 18.4184 21.5655 19.0418L21.9211 16.5524C21.9701 16.2091 21.8378 15.8648 21.5713 15.6428L17.2628 12.0523C16.5476 11.4563 15.496 11.504 14.8377 12.1623L9.84853 17.1515C9.3799 17.6201 8.6201 17.6201 8.15147 17.1515L7.07822 16.0782C6.45603 15.456 5.47521 15.3749 4.7592 15.8863L2.91876 17.2009C2.65597 17.3886 2.5 17.6917 2.5 18.0146V19.0194C2.5 19.0894 2.50734 19.1586 2.52154 19.2259C2.18774 18.5555 2 17.7997 2 17V7ZM19.238 21.3096L21.1641 19.7688C20.2679 21.1138 18.7374 22 17 22H7C5.26076 22 3.72892 21.112 2.83318 19.7646C2.84685 19.7768 2.86089 19.7887 2.87531 19.8002L4.75317 21.3025C4.91381 21.431 5.11017 21.5069 5.31548 21.5197L12.9272 21.9955C12.9757 21.9985 13.0243 21.998 13.0727 21.9939L18.6963 21.5253C18.8943 21.5088 19.0828 21.4337 19.238 21.3096ZM8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.c329464d634f9ffdbbfab5e259af4da1.svg";
export { ForwardRef as ReactComponent };